import { render, staticRenderFns } from "./InicialEdit.vue?vue&type=template&id=5c7bbf16&lang=true&"
import script from "./InicialEdit.vue?vue&type=script&lang=js&"
export * from "./InicialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports